const styles = (theme) => ({
  paperContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "flex-start",
    whiteSpace: "nowrap",
    padding: "15px 15px",
    boxShadow: "none",
  },
  paperControls: {
    display: "flex",
    flexDirection: "row-reverse",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "100%",
  },
  providerStatusIndicatorInactive: {
    width: "12px",
    height: "12px",
    backgroundColor: "#ccc",
    borderRadius: "50%",
    transition: "all 0.3s ease",
    marginRight: "8px",
  },
  providerStatusIndicatorActive: {
    width: "12px",
    height: "12px",
    backgroundColor: "#4caf50",
    borderRadius: "50%",
    transition: "all 0.3s ease",
    marginRight: "8px",
  },
  providerStatusText: {},
  providerStatus: {
    display: "flex",
    flexDirection: "row",
    alignContent: "center",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
  },
  providerDetailsPaperClosed: {
    maxHeight: 0,
    overflow: "hidden",
    transition: "max-height 0.3s ease-out",
    marginTop: "-9px",
    boxShadow: "none",
    backgroundColor: "#f5f5f5",
  },
  providerDetailsPaperOpen: {
    maxHeight: "500px",
    overflow: "hidden",
    transition: "max-height 0.3s ease-in",
    marginTop: "-9px",
    boxShadow: "none",
    backgroundColor: "#f5f5f5",
  },
  providerPaper: {
    marginBottom: "10px",
    cursor: "pointer",
  },
  providerDetailsHeading: {
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "10px",
    color: "#bbb",
  },
  providerDetailsInput: {
    marginBottom: "15px",
  },
  providerFindingSetting: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
  },
  selectOneTagWarning: {
    marginTop: "5px",
    color: "#f4368b",
  },
  providerDetailsActionButtons: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "flex-end",
    gap: "10px",
    color: "#f4368b",
    fontWeight: "bold",
    fontSize: "15pt",
    marginTop: "20px",
  },
  providerDisclaimer: {
    marginTop: "15px",
    color: "dimgray",
    fontSize: "large",
  },
});

export default styles;
